// extracted by mini-css-extract-plugin
export default {"button":"dgFo","button-center":"GFZa","buttonCenter":"GFZa","icon":"Fqzf"};